
<div v-if="!isLoading && chartData.length > 0" class="EntityDetailsChart">
    <ChartV2
        type="bar"
        halfHeight
        color="green"
        :title="`Umsatz ${currentMonthDisplay}`"
        :values="chartData"
        :isLoading="isLoading"
    />
</div>
